// Referto messo in sospeso quando l'utente incontra il paywall e va a pagare.
//
// `sessionStorage`, non `localStorage`: il payload contiene i dati di screening del
// lavoratore — dati sanitari — e non deve sopravvivere alla chiusura del browser. Viene
// scritto solo alla ricezione del 402 (utente in procinto di pagare), mai durante la
// normale compilazione del wizard.
const KEY = "vs_pending_report";
const MAX_AGE_MS = 2 * 60 * 60 * 1000; // 2 ore

// Logo e firma non vengono mai serializzati. Due ragioni, entrambe dirimenti: la firma
// autografa del medico è l'artefatto più sensibile del prodotto e non deve toccare il
// disco; e i due dataURL base64 da soli possono superare la quota di sessionStorage,
// facendo fallire il salvataggio proprio mentre l'utente sta andando a pagare. Al
// ripristino li riconsegna comunque /reports/authorize.
function withoutAssets(data) {
  const { logo, firma, ...patient } = data.patient || {};
  return { ...data, patient };
}

export function savePendingReport({ reportId, data, step }) {
  try {
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ reportId, data: withoutAssets(data), step, savedAt: Date.now() }),
    );
    return true;
  } catch {
    // Safari in navigazione privata può negare sessionStorage: si degrada, non si rompe.
    return false;
  }
}

export function loadPendingReport() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p || !p.reportId || !p.data || !p.savedAt || Date.now() - p.savedAt > MAX_AGE_MS) {
      clearPendingReport();
      return null;
    }
    return p;
  } catch {
    clearPendingReport();
    return null;
  }
}

// Passa da `loadPendingReport` invece di leggere la chiave direttamente: scadenza e
// payload corrotto restano gestiti in un punto solo, e un pending scaduto risulta
// correttamente assente.
export function hasPendingReport() {
  return loadPendingReport() !== null;
}

export function clearPendingReport() {
  try { sessionStorage.removeItem(KEY); } catch { /* noop */ }
}
